<span class="btn_right">
  <label class="switch">
    <ng-container *ngIf="this.activity.toggleFlag">
        <input type="checkbox" (change)="dispActivities($event)" checked [formControl]="toggleFlagCtl">
    </ng-container>

    <ng-container *ngIf="this.activity.toggleFlag === false">
        <input type="checkbox" (change)="dispActivities($event)" [formControl]="toggleFlagCtl">
    </ng-container>

      <div class="slider round" >
        <span class="on">{{ 'YesToggle' | translate}}</span>
        <span class="off">{{ 'NoToggle' | translate}}</span>

      </div>
  </label>

  </span>
